import {
  CHANGE_PASSPORT_DATA,
  BLUR_PASSPORT_DATA,
  CHANGE_DOCUMENT_TYPE
} from '../constants';

export const changePassportData = payload => ({
  type: CHANGE_PASSPORT_DATA,
  payload
});
export const blurPassportData = payload => ({
  type: BLUR_PASSPORT_DATA,
  payload
});
export const changeDocumentType = payload => ({
  type: CHANGE_DOCUMENT_TYPE,
  payload
});
